import { Crown, Star, Users } from "lucide-react";

export const plans = [
  {
    id: "free",
    name: "Free",
    price: "$0",
    period: "forever",
    lookupKey: "free",
    description: "Perfect for getting started",
    features: {
      users: 2,
      saveMappings: false,
      mappingsToStore: 0,
      executions: 10,
    },
    popular: false,
    buttonText: "Current Plan",
    buttonStyle: "bg-gray-100 text-gray-500 cursor-not-allowed",
    icon: <Star className="w-6 h-6" />,
  },
  {
    id: "basic",
    name: "Basic",
    price: "$20",
    period: "per month",
    description: "Great for small teams",
    features: {
      users: 5,
      saveMappings: true,
      mappingsToStore: 25,
      executions: 100,
    },
    popular: true,
    buttonText: "Upgrade to Basic",
    buttonStyle: "bg-blue-600 hover:bg-blue-700 text-white",
    icon: <Users className="w-6 h-6" />,
    lookupKey: "basic",
  },
  {
    id: "premium",
    name: "Premium",
    price: "$40",
    period: "per month",
    description: "For growing businesses",
    features: {
      users: 25,
      saveMappings: true,
      mappingsToStore: 100,
      executions: 500,
    },
    popular: false,
    buttonText: "Upgrade to Premium",
    buttonStyle:
      "bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-white",
    icon: <Crown className="w-6 h-6" />,
    lookupKey: "premium",
  },
];

export const infoContent = {
  fileSettings: {
    title: "File Settings",
    description:
      "Enter the row number that contains the column headers in your CSV or Excel file so the system can read it correctly.",
  },
  outputFileSettings: {
    title: "Output File Settings",
    description:
      "Define how the processed file should be exported, including structure, headers, and output rules. The 'Skip Rows' field lets you choose how many rows to leave blank before writing new data. For example, if you enter 1, row 1 will contain data, row 2 will be left blank, and new data will start from row 3. If you enter 2, row 1 will contain data, rows 2 and 3 will be left blank, and new data will start from row 4.",
  },
  grpby: {
    title: "Group By Feature",
    description:
      "Group data by selected columns and apply aggregation functions like sum, count, or average.",
  },
  addCharacterCodes: {
    title: "Add Character Codes",
    description:
      "Append custom characters or codes to your dataset based on defined rules.",
  },
  mergeColumns: {
    title: "Merge Columns",
    description:
      "Combine two or more columns into a single column. This feature works for both input and output files.",
  },
  Aggregate: {
    title: "Aggregate Feature",
    description:
      "Summarize data by applying functions like sum, average, or count to specified columns, grouped by one or more other columns.",
  },
  find: {
    title: "Find Feature",
    description:
      "Identify and store the row indexes where specific values, such as dates, numbers, or text, appear in your dataset. These indexes can then be used to perform further operations only on the relevant rows. For example, extracting data from matching columns or skipping unwanted entries. This is especially useful when your file contains skipped or mixed rows and you want to target only the rows with valid data.",
  },
  formula: {
    title: "Formula Feature",
    description:
      "Apply custom formulas to your data using functions and operators. You can perform calculations, modify column values, or generate new fields based on your requirements.",
  },
  duplicate: {
    title: "Duplicate Feature",
    description:
      "Use this feature to append data multiple times based on indexes generated from a previous rule, such as the Find function. First, select the output column where the data should be added. Then, choose whether to use the results from a previous step—for example, indexes of rows containing dates. Using those indexes, you can duplicate and append the same values once or multiple times as needed.",
  },
  skipCondition: {
    title: "Skip Condition Feature",
    description:
      "Skip Condition allows you to remove entire rows from the input file based on defined criteria. You can specify conditions to match specific cell values, or automatically skip rows where a cell is empty, null, or undefined. This helps filter out unwanted or invalid data during processing.",
  },
  CreateCustomColumn: {
    title: "Create Custom Column Feature",
    description:
      "Create a new column by using the output of a previous rule, such as indexes from the Find function. You can extract data from existing columns, apply operations to it, and append the result to an output column. During this process, you can also choose to skip empty cells or ignore zero values as needed.",
  },
  swt: {
    title: "Switch Column Feature",
    description:
      "Copy data from a selected input column and paste it into a specified output column. This is a direct transfer of column values without any modification.",
  },

  InvoiceGenerator: {
    title: "Invoice Number Configuration",
    description:
      "Customize how invoice numbers are generated by adding and arranging components such as prefixes, date formats, sequential numbers, and suffixes to create a unique invoice numbering system that fits your business needs.",
  },
};
